import { render, staticRenderFns } from "./relationNew.vue?vue&type=template&id=d9ba011a&scoped=true"
import script from "./relationNew.vue?vue&type=script&lang=js"
export * from "./relationNew.vue?vue&type=script&lang=js"
import style0 from "./relationNew.vue?vue&type=style&index=0&id=d9ba011a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ba011a",
  null
  
)

export default component.exports